import { render, staticRenderFns } from "./advaccru.vue?vue&type=template&id=17b2c854"
import script from "./advaccru.vue?vue&type=script&lang=js"
export * from "./advaccru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports